import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {
  BOOKING_URL,
  trackBookingClick,
  trackAccordionExpand,
} from "../../utils/tracking";

const parseCostToNumber = (cost) => {
  if (typeof cost === "number") return cost;
  if (typeof cost === "string") {
    const cleaned = cost.replace(/[^0-9.]/g, "");
    const parsed = Number.parseFloat(cleaned);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

const calculateNewCost = (cost) => {
  const baseCost = parseCostToNumber(cost);
  if (baseCost === null) {
    return { formatted: String(cost), numeric: false };
  }

  const newCost = baseCost * 1;
  return { formatted: newCost.toFixed(2), numeric: true };
};

const ServiceAccordion = ({ service, isExpanded, onChange }) => {
  const isConsultation =
    service.id === "medik8-consultation" ||
    service.id === "consultation-treatment";

  const { formatted: newCost, numeric: isNumericPrice } = calculateNewCost(
    service.price,
  );

  const displayPrice = !isNumericPrice
    ? newCost
    : isConsultation
      ? newCost
      : `£${newCost}`;

  return (
    <Accordion
      expanded={isExpanded}
      onChange={(event, expanded) => {
        if (expanded) trackAccordionExpand(service.name, "Service Accordion");
        onChange(event, expanded);
      }}
      sx={{
        boxShadow: "none",
        border: "1px solid var(--color-border)",
        borderRadius: "8px !important",
        mb: 1.5,
        "&:before": { display: "none" },
        "&.Mui-expanded": {
          margin: "0 0 12px",
          boxShadow: "0 2px 12px rgba(90, 77, 71, 0.08)",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: "var(--color-primary)" }} />}
        sx={{ py: 0.5 }}
      >
        <Typography
          variant="body2"
          sx={{
            width: "55%",
            flexShrink: 0,
            fontFamily: "var(--font-body)",
            fontWeight: 500,
            color: "var(--color-primary)",
            fontSize: "15px",
          }}
        >
          {service.name}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "var(--color-text-muted)",
            fontStyle: "italic",
            fontSize: "14px",
            fontFamily: "var(--font-body)",
          }}
        >
          {service.duration} — {displayPrice}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0, pb: 2 }}>
        <Typography
          variant="body2"
          sx={{
            whiteSpace: "pre-line",
            fontFamily: "var(--font-body)",
            fontSize: "14px",
            lineHeight: 1.7,
            color: "var(--color-text-light)",
          }}
        >
          {service.description}
        </Typography>
      </AccordionDetails>
      <AccordionDetails sx={{ pt: 0 }}>
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noreferrer"
          onClick={() => trackBookingClick(service.name)}
          style={{
            display: "inline-block",
            backgroundColor: "#5a4d47",
            color: "#fff",
            padding: "10px 24px",
            borderRadius: "4px",
            textDecoration: "none",
            fontSize: "13px",
            fontWeight: 600,
            fontFamily: "'Montserrat', sans-serif",
            letterSpacing: "0.3px",
            transition: "all 0.3s ease",
          }}
        >
          Book This Treatment
        </a>
      </AccordionDetails>
    </Accordion>
  );
};

export default ServiceAccordion;
